import type { IButtonLoaderProps } from "@components/atoms/loader/types";
import { useThemeVariable } from "@/theme";
import "ldrs/dotPulse";

export function ButtonLoader({ size, color }: IButtonLoaderProps) {
  const defaultColor = color || "primary-dark";
  const name = defaultColor?.includes("fix")
    ? `--rgb-${defaultColor}`
    : `--theme-${defaultColor}`;
  const { color: themeColor } = useThemeVariable(name);

  return <l-dot-pulse size={size || "43"} speed={"1"} color={themeColor} />;
}
